export enum ZendeskKeys {
  EU_KEY = 'e3975b8f-6479-4be9-8f04-395360c62a56',
  LATAM_KEY = '296c4c98-226f-4454-bdda-ae4d5c2232bf'
}
